import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "g-row g-row--justify_center g-row--appearance_spaced g-row--space_lg g-row--space_2xl-xl g-row--align_center" }
const _hoisted_2 = { class: "subscription-card__title" }
const _hoisted_3 = { class: "ds-caption ds-caption--size_3exxl ds-caption--size_4xls-xl ds-caption--bold ds-caption--color_dark-blue ds-caption--appearance_center" }
const _hoisted_4 = { class: "ds-caption ds-caption--size_3xs ds-caption--size_md-xl ds-caption--thin ds-caption--color_blue ds-caption--appearance_center" }
const _hoisted_5 = {
  key: 0,
  class: "subscription-card__advantage"
}
const _hoisted_6 = { class: "ds-caption ds-caption--size_3xs ds-caption--size_lg-xl ds-caption--bold ds-caption--color_green" }
const _hoisted_7 = { class: "subscription-card__price subscription-card__price--old" }
const _hoisted_8 = { class: "ds-caption ds-caption--size_2md ds-caption--size_xl-xl ds-caption--medium ds-caption--color_middle-gray ds-caption--appearance_right ds-caption--appearance_center-xl" }
const _hoisted_9 = { class: "subscription-card__price subscription-card__price--new" }
const _hoisted_10 = { class: "ds-caption ds-caption--size_5xl ds-caption--size_2exl-xl ds-caption--medium ds-caption--color_dark-blue ds-caption--appearance_left ds-caption--appearance_center-xl" }
const _hoisted_11 = { class: "subscription-card__button" }
const _hoisted_12 = { class: "ds-panel ds-panel--space_2xl ds-panel--space_sm-xl" }
const _hoisted_13 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "g-row g-row--space_xs g-row--align_center" }
const _hoisted_16 = { class: "g-cell g-cols-narrow" }
const _hoisted_17 = { class: "ds-caption ds-caption--size_3xs ds-caption--size_2md-xl ds-caption--bold ds-caption--color_white ds-caption--nowrap" }
const _hoisted_18 = { class: "subscription-card__price subscription-card__price--for-year" }
const _hoisted_19 = { class: "ds-caption ds-caption--size_3xs ds-caption--size_2md-xl ds-caption--color_middle-gray ds-caption--appearance_center" }
const _hoisted_20 = { class: "line-through" }
const _hoisted_21 = { class: "subscription-card__button subscription-card__button--decore not-clickable" }
const _hoisted_22 = { class: "hq-btn hq-btn--simple-light-green hq-btn--centered hq-btn--full_width link" }
const _hoisted_23 = { class: "g-row g-row--space_xs g-row--align_center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "g-cell g-cols-narrow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hq-btn__icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "hq-btn__img star-img",
      src: "/static/app/star-icon.svg",
      alt: "star icon",
      width: "12",
      height: "11",
      title: ""
    })
  ])
], -1)
const _hoisted_25 = { class: "g-cell g-cols-narrow" }
const _hoisted_26 = { class: "hq-btn__text ds-caption ds-caption--size_2xs ds-caption--size_sm-xl ds-caption--bold ds-caption--color_white ds-caption--nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.subList || $props.list, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "g-cell g-cols g-cols--narrow-md g-cols--4-xl",
        style: _normalizeStyle(`order: ${$setup.getOrder(item, i)}`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["subscription-card subscription-card--mobile", $setup.percentDiff(item.price_sale, item.price_default) == $setup.bestPrice ? "subscription-card--active" : "" + item.price_default == item.price_sale ? "subscription-card--no-sale" : "" ])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(item.title), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["subscription-card__period", !item.saving ? "subscription-card__period--centered" : ""])
          }, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(item.label), 1)
          ], 2),
          (item.price_sale)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString($setup.$t('Экономия')), 1),
                  _createElementVNode("span", null, _toDisplayString(" ") + _toDisplayString($setup.percentDiff(item.price_sale, item.price_default)) + _toDisplayString("%"), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString("$") + " " + _toDisplayString(item.price_default.replace('.', ',')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString("$") + " " + _toDisplayString(item.price_sale.replace('.', ',')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("a", {
                  class: "hq-btn hq-btn--simple-blue hq-btn--centered hq-btn--full_width hq-btn--shadowed hq-btn--subscription-style",
                  onClick: _withModifiers(($event: any) => ($setup.setNextStep(item)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString($setup.$t('Выбрать подписку')), 1)
                    ])
                  ])
                ], 8, _hoisted_14)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString("$") + " " + _toDisplayString(item.price_default * item.months_count) + " " + _toDisplayString(" "), 1),
              _createElementVNode("span", null, _toDisplayString(" $") + " " + _toDisplayString(item.price_sale * item.months_count) + " " + _toDisplayString(" "), 1),
              _createElementVNode("span", null, _toDisplayString($setup.$t('за')) + " " + _toDisplayString(item.label), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", _hoisted_26, _toDisplayString($setup.$t('Лучшая цена')), 1)
                ])
              ])
            ])
          ])
        ], 2)
      ], 4))
    }), 128))
  ]))
}